function t(){return-this.snapGrid[this.snapGrid.length-1]}export{t as default};
//# sourceMappingURL=maxTranslate.js.map
